import script from "./CancellationReasonsDecision.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancellationReasonsDecision.vue?vue&type=script&setup=true&lang=ts"

import "./CancellationReasonsDecision.vue?vue&type=style&index=0&id=26663cfa&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26663cfa"]])

export default __exports__